"use strict"

const initialState = {
    devicesObservations: {}
}

const getters = {
    devicesObservations: state => state.devicesObservations
}

const actions = {
    addObservationSet({commit, state}, observationsAndId) {
        commit('addObservationSet', observationsAndId)
    },
    removeObservationSetsFromStore({commit, state}) {
        commit('removeObservationSetsFromStore')
    },
}

const mutations = {
    addObservationSet(state, observationsAndId) {
        let deviceId = observationsAndId.deviceId
        let observationSet = observationsAndId.observationSets
        state.devicesObservations[deviceId] = []
        state.devicesObservations[deviceId] = observationSet;
    },
    removeObservationSetsFromStore(state) {
        state.devicesObservations = {}
    },
}

export default {
    state: {...initialState},
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/app/store/modules/observations.js